module.exports = __webpack_public_path__ + "img/s13-txt1.c2718d08.png";